<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="half"><a id="page_i"></a>In Search of Angels<a id="page_ii"></a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half.vue?1bb942e4